import React, { useState } from "react";
import RangeSlider from "../WebsiteComponents/RangeSlider";
import { CURRENCY } from "src/lib/constans";

interface IProps {
  title?: string;
  min: number;
  max: number;
  onChange: (min: number, max: number) => void;
  borderBottom?: boolean;
}

const PriceRangeSelector = ({
  title,
  min,
  max,
  onChange,
  borderBottom = true,
}: IProps) => {
  const [minRange, setMinRange] = useState(0);
  const [maxRange, setMaxRange] = useState(100000);
  return (
    <div className={`w-full p-2 2xl:p-3 ${borderBottom ? "border-b border-gray-300" : "border-none"}`}>
      <h2 className="font-Poppins-Medium font-size-18px theme-color-green mb-3">
        {title || `Price Range (${CURRENCY})`}
      </h2>
      <RangeSlider
        minRange={minRange}
        maxRange={maxRange}
        step={100}
        currentRanges={[min, max]}
        changePriceRanges={(val) => {
          onChange(val[0], val[1]);
        }}
        showDoneBtn={false}
      />
    </div>
  );
};

export default PriceRangeSelector;
